package com.exura.features.plandefinition.data.repository

import com.exura.features.firebase.data.repository.BaseFirestoreRepository
import com.exura.features.plandefinition.data.mappers.plandefinition.PlanElementMappers
import com.exura.features.plandefinition.data.remote.dto.element.BasePlanElementDto
import com.exura.features.plandefinition.domain.model.element.BasePlanElement
import com.exura.features.plandefinition.domain.repository.PlanElementsRepository
import dev.gitlive.firebase.firestore.CollectionReference
import dev.gitlive.firebase.firestore.DocumentReference
import dev.gitlive.firebase.firestore.DocumentSnapshot
import dev.gitlive.firebase.firestore.FirebaseFirestore
import kotlinx.serialization.modules.SerializersModule

class PlanElementsRepositoryImpl(
    firestore: FirebaseFirestore,
    dtoSerializersModule: SerializersModule,
    mapper: PlanElementMappers<BasePlanElement, BasePlanElementDto>,
) : PlanElementsRepository, BaseFirestoreRepository<BasePlanElement, BasePlanElementDto>(
    firestore = firestore,
    dtoSerializersModule = dtoSerializersModule,
    mapper = mapper
) {
    override suspend fun getDto(doc: DocumentSnapshot): BasePlanElementDto = doc.data { serializersModule = dtoSerializersModule }

    override suspend fun setDto(dto: BasePlanElementDto, dest: DocumentReference): DocumentReference {
        dest.set(dto) { serializersModule = dtoSerializersModule }
        return dest
    }

    override suspend fun addDto(dto: BasePlanElementDto, dest: CollectionReference): DocumentReference =
        dest.add(dto) { serializersModule = dtoSerializersModule }
}
